module.exports = __webpack_public_path__ + "static/media/PDF_121.b58d0864.pdf";